import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { UtilService } from 'src/app/shared/services';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-fundraiser-card-old',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, SharedModule],
  templateUrl: './fundraiser-card-old.component.html',
  styleUrls: ['./fundraiser-card-old.component.scss']
})
export class FundraiserCardOldComponent {

  @Input() fundraisersList;
  @Input() taxBenefit;

  constructor(
    public util: UtilService
  ) { }

}
